import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import styled from '@emotion/styled';
import {useMediaQuery} from '@material-ui/core';

const useStyles = makeStyles({
    root: {},
    paper: {
        top: 'var(--header-height) !important',
        height: 'calc(100vh - var(--header-height))',
        overflowY: 'hidden'
    },
    paperAnchorBottom: {
        // left: "auto",
        // width: "calc(100vw - 331px)"
    }
});

const DrawerContent = styled.div`
    height: 100%;
`;

const mobileScreenStyles = makeStyles({
    root: {},
    paper: {
        boxShadow: '-4px 0px 6px rgba(0, 0, 0, 0.05), -10px 0 15px rgba(0, 0, 0, 0.1)',
        overflowY: 'hidden'
    }
});

const backDropStyles = makeStyles({
    root: {
        left: 'auto',
        top: 'var(--header-height) !important',
        width: 'calc(100vw - 100px)',
        height: 'calc(100vh - var(--header-height))'
    }
});

export default function CustomSidePanel(props) {
    const {open, onDrawerClose} = props;
    const drawersStyles = useStyles();
    const mobileDrawerStyles = mobileScreenStyles();
    const backDropClasses = backDropStyles();
    const lgUp = useMediaQuery('(min-width:1280px)');

    const lgScreen = {
        root: drawersStyles.root,
        paper: drawersStyles.paper,
        paperAnchorBottom: drawersStyles.paperAnchorBottom
    };

    const mobileScreen = {paper: mobileDrawerStyles.paper};

    return (
        <Drawer
            anchor="right"
            open={open}
            elevation={0}
            ModalProps={{BackdropProps: {classes: {root: lgUp ? backDropClasses.root : mobileDrawerStyles.root}}}}
            classes={(lgUp) ? lgScreen : mobileScreen}
            onBackdropClick={onDrawerClose}
            onClose={onDrawerClose}
        >

            <DrawerContent>
                {props.children}
            </DrawerContent>
        </Drawer>
    );
}

CustomSidePanel.propTypes = {
    open: PropTypes.bool,
    onDrawerClose: PropTypes.func.isRequired
};
